import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareAgentContextClassicRoute: InvariantJiraRoute = {
	name: 'software-agent-context-classic',
	path: '/jira/software/c/projects/:projectKey/agent-context',
	exact: true,
};
